import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { getPropByName } from '../../../utils/props';
import { CompanyTransportLocations } from './CompanyTransportLocations';
import { CompanyAddresses } from './CompanyAddresses';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const STATE = {
  addCompanyAddress: false,
};

/* eslint-disable react/prefer-stateless-function */
class CompanyAddressesCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    const company = this.props.company;
    return (
      <>
        <Card className="company-info-card info-card data">
          <Container>
            <CompanyAddresses company={company} />
          </Container>
        </Card>

        {env.clientId !== AppClientId.HILTERMANN && (
          <Card className="company-info-card info-card data">
            <Container>
              <CompanyTransportLocations company={company} />
            </Container>
          </Card>
        )}
      </>
    );
  }

  renderAddress(address, index) {
    return (
      <Row clickable key={address.id} onClick={this.tofn(`/addresses/${address.id}`)}>
        <Cell>{getPropByName(address, 'name', '')}</Cell>
      </Row>
    );
  }
}

CompanyAddressesCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyAddressesCard = compose(withConnect, withRouter)(CompanyAddressesCardComp);
